export default __webpack_public_path__ + "static/media/bbss_logo.5493b38e.png";